/**
 * <SignedAvatar> — un visage et le signe posé à son coin (molecule).
 *
 * La photo ou l'initiale d'un élève, et une pastille ronde à son coin bas-droit qui dit ce qui se passe
 * (la main, le chrono, le fantôme…, l'emoji de l'ancien panneau d'événements du live, en glyphe). Le fil
 * de la séance la pose sur chaque entrée, et sur ses visages quand la colonne est repliée. La pastille
 * suit la taille du visage ; son encre est celle de son aplat, que l'appelant donne.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Avatar } from "../../atoms/Avatar"
import { Icon, type IconName } from "../../atoms/icons/Icon"
import { type SemanticColorKey } from "../../theme/tokens/colors"

/** Le signe : son glyphe, la couleur de sa pastille et son encre. */
export type AvatarSign = { icon: IconName; color: SemanticColorKey; ink: SemanticColorKey }

export type SignedAvatarProps = {
    uri?: string
    name: string
    size: number
    sign?: AvatarSign
    /** L'anneau de sélection de l'univers. Défaut `false`. */
    selected?: boolean
    testID?: string
}

export function SignedAvatar(props: SignedAvatarProps) {
    const { uri, name, size, sign, selected = false, testID } = props
    const signSize = Math.round(size * 0.55)
    return (
        <View testID={testID}>
            <Avatar uri={uri} name={name} size={size} selected={selected} />
            {sign != null && (
                <View style={styles.sign(sign.color, signSize)}>
                    <Icon name={sign.icon} size={Math.round(signSize * 0.62)} color={sign.ink} />
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    sign: (color: SemanticColorKey, size: number) => ({
        position: "absolute" as const,
        right: -size / 4,
        bottom: -size / 4,
        width: size,
        height: size,
        borderRadius: size / 2,
        alignItems: "center" as const,
        justifyContent: "center" as const,
        backgroundColor: theme.colors[color],
        borderWidth: 1.5,
        borderColor: theme.colors.surface,
    }),
}))
